import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';

import LogoImg from '../assets/img/Logo.png';
import SnehoImg from '../assets/img/Logo.png';
import './prescriptionPreviewStyle.css';
import {axiosInstance} from '../components/helper/axiosConfig';
import html2canvas from 'html2canvas';
import SocialShareModal from './socialShareModal';
import PrescriptionPreviewSkeleton from './prescriptionPreviewSkeleton';
import toast, { Toaster } from 'react-hot-toast';
import InvestigationUploadModal from "./InvestigationUploadModal";
import { isAdmin, isDoctor } from '../components/helper/authRoles';
import { Helmet } from 'react-helmet';

const PrescriptionPreviewPartner = () => {
  const { prescription_id } = useParams();
  const [Prescription, setPrescription] = useState(null);
  const [Doctor, setDoctor] = useState(null);
  const [Patient, setPatient] = useState(null);
  const [Medication, setMedication] = useState(null);
  const [Signature, setSignature] = useState('');
  const [PrescriptionLogo, setPrescriptionLogo] = useState(SnehoImg);

  const [ShareModalVisible, setShareModalVisible] = useState(false);
  const [DataLoading, setDataLoading] = useState(true);
  const [showDiv, setShowDiv] = useState(true);
  // const prescriptionURL = `${process.env.REACT_APP_AXIOS_BASE_URL}/api/rx/${prescription_id}`;
  const prescriptionURL = window.location.href;
  // const user_info = JSON.parse(localStorage.getItem('user-info'));
  // const token = user_info.token;
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);

  // Function to open the modal
  const openModal = () => {
    setModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setModalOpen(false);
  };


  const fetchMedication = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/medication_by_prescription/${prescription_id}`
      );
      const data = response.data;
      setMedication(data);
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  };

  const fetchSignature = async (doctor_id) => {
    try {
      const response = await axiosInstance.get(
        `/api/v2/doctor-setting/?doctor=${doctor_id}`
      );
      const data = response.data.results.length ? response.data.results : response.data;
      setSignature(data[0].signature);
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  };

  const fetchPrescriptionLogo = async (doctor_id) => {
    try {
      const response = await axiosInstance.get(
        `/api/v2/doctor-setting-prescription/?doctor=${doctor_id}`
      );
      const data = response.data.results.length ? response.data.results : response.data;
      setPrescriptionLogo(data[0].prescription_logo);
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  };



  const SentenceCase = (Sentence) => {
    return Sentence.charAt(0).toUpperCase() + Sentence.slice(1);
  };


const newDownloadPrintableDocument = () => {
  if (!isLoading) {
    // Select the target element (prescription-container) that you want to download
    const targetElement = document.getElementById('prescription_preview');

    // Use html2canvas to capture the target element as a canvas
    html2canvas(targetElement)
      .then((canvas) => {
        // Convert the canvas to a data URL representing the PNG file
        const dataUrl = canvas.toDataURL('image/png');

        // Create a link element to trigger the download
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'prescription.png';

        // Simulate a click on the link element to start the download
        link.click();
      })
      .catch((error) => {
        console.error('Error generating printable document:', error);
      });
  }
};

const handleDownload = async () => {
  const printContent = document.getElementById('prescription_preview');
  const signatureImage = document.querySelector('.signature-image');

  // Wait for the signature image to load completely
  const loadImage = () => {
    return new Promise((resolve, reject) => {
      if (signatureImage.complete && signatureImage.naturalHeight !== 0) {
        resolve();
      } else {
        signatureImage.onload = resolve;
        signatureImage.onerror = reject;
      }
    });
  };

  try {
    // Ensure the signature image is loaded before rendering the canvas
    await loadImage();

    // Use html2canvas with useCORS option
    html2canvas(printContent, { useCORS: true }).then((canvas) => {
      // Convert the canvas to a data URL
      const dataURL = canvas.toDataURL('image/png');

      // Create a temporary anchor element
      const anchor = document.createElement('a');
      anchor.href = dataURL;
      anchor.download = 'prescription_from_sneho.png';

      // Simulate a click event to trigger the download
      anchor.click();
    });
  } catch (error) {
    console.log('Error loading signature image:', error);
  }
};


  const prevPrintDocument = (domElement) => {
    html2canvas(domElement).then((canvas) => {
      // document.body.appendChild(canvas);
      let a = document.createElement('a');
      a.href = canvas.toDataURL('image/png');
      a.download = `prescription_${prescription_id}.png`;
      a.click();
    });
  };

  const uploadInvestigation = async () => {

  };


  const setCopyURL = async () => {
    // var copyText = document.getElementById("urlInput");

    // /* Select the text field */
    // copyText.select();
    // copyText.setSelectionRange(0, 99999); /* For mobile devices */
    // console.log('--',copyText.value);

    /* Copy the text inside the text field */
    // navigator.clipboard.writeText(copyText.value);
    await navigator.clipboard.writeText(window.location.href);

    /* Alert the copied text */
    //toast('Prescription URL has been copied, you can past it anywhere !', {
    //  icon: '👏',
    //});
    alert('Prescription URL has been copied, you can past it anywhere ');
  };


const setForPrint = async () => {
  await navigator.clipboard.writeText(window.location.href);
  const printContent = document.getElementById('prescription_preview').innerHTML;
  const originalContents = document.body.innerHTML;

  // Add event listener to refresh on print completion
  window.onafterprint = () => {
    window.location.reload();
  };

  document.body.innerHTML = printContent;
  window.print();
  document.body.innerHTML = originalContents;
};

  const handleLogoLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    setDataLoading(true);
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_AXIOS_BASE_URL}/api/prescription/${prescription_id}`
      )
      .then(async (response) => {
        const data = response.data;
        console.log(data);
        setPrescription(data);
        fetchPrescriptionLogo(data.doctor);
        axios
          .get(
            `${process.env.REACT_APP_AXIOS_BASE_URL}/api/doctor/${data.doctor}`
          )
          .then((response) => {
            setDoctor(response.data);
            fetchSignature(data.doctor);
            fetchPrescriptionLogo(data.doctor);
          });

        await axios
          .get(
            `${process.env.REACT_APP_AXIOS_BASE_URL}/api/patient/${data.patient}`
          )
          .then((response) => {
            setPatient(response.data);
          });

        await fetchMedication();
        setDataLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setDataLoading(false);
      });



    const urlParams = new URLSearchParams(window.location.search);
    const queryStringExists = urlParams.has('sneho');

    if (queryStringExists) {
      setShowDiv(true);
    }



  }, [prescription_id]);

  const canvasRef = useRef(); //useref ta import kora lagbe

  if (DataLoading) return <PrescriptionPreviewSkeleton />;
  else
    return (
      <div className='prescription-page'>

        <Helmet>
          {/* Remove the viewport meta tag
          <meta name="viewport" content="" />*/}
        </Helmet>

        {true && (
          <SocialShareModal
            modalVisible={ShareModalVisible}
            setModalVisible={setShareModalVisible}
          />
        )}
        <div className='prescription-main'>
        <div
          ref={canvasRef}
          className='prescription-container ppm'
          id='prescription_preview'
        >
          <div className='header-wrapper'>
            <div className='header-partL' >
              {/* <div className='prescription-item-title'>Powered By.</div> */}

                <div className='logo-container'>
                  <div className='logo-wrapper'>
                    <img className='brand-logo new' style={{ marginLeft: '0px' }} src={PrescriptionLogo} alt='' />
                  </div>
                  <span className="p-id">Prescription Id: #247</span>
                </div>


            </div>
            {/* <div className='header-partM'></div> */}
            <div className='header-partR'>
              {Doctor && (
                <div className='header-textR'>
                    <div className='doc-name'>
                      {Doctor.title ? Doctor.title + ' ' : ''}
                      {Doctor.full_name || ''}
                    </div>

                    <div className='doc-speciality'>
                      {Doctor.degree || ''}
                    </div>

                    {Doctor.bio && (
                      <div className='doc-professional-bio'>
                      <div
                          className='doctor-bio'
                          dangerouslySetInnerHTML={{
                            __html: Doctor.bio
                              ? Doctor.bio.split(' ').map((word, index) =>
                                  (index + 1) % 7 === 0 ? `${word}<br/>` : word
                                ).join(' ')
                              : ''
                          }}
                          />
                      </div>
                    )}
                    {/*}
                    <div className='doc-contact-section'>
                      {Doctor.mobile_number && (
                        <div className='doc-mobile'>
                          {Doctor.mobile_number}
                        </div>
                      )}
                      {Doctor.mobile_number && Doctor.email && ', '}
                      {Doctor.email && (
                        <div className='doc-email'>
                          {Doctor.email}
                        </div>
                      )}
                    </div>

                    {(Doctor.address_thana || Doctor.address_district) && (
                      <div className='doc-address'>
                        {Doctor.address_thana ? Doctor.address_thana + ', ' : ''}
                        {Doctor.address_district || ''}
                      </div>
                    )}
                    */}
                    {(Doctor.bmdc_number || Doctor.bmdc_number) && (
                      <div className='doc-address'>
                        BMDC Reg. No. {Doctor.bmdc_number || ''}
                      </div>
                    )}
                </div>

              )}
            </div>
          </div>

          <div className='patient-wrapper'>
            <div className='patient-details'>
              <div className='patient-part'>
                Name: {Patient && <span>{Patient.name}</span>}
              </div>
              <div className='patient-part'>
                Age:{' '}
                {Patient && (
                  <span>
                    {Patient.age} {Patient.age_type}s
                  </span>
                )}
              </div>
              <div className='patient-part'>
                Sex:{' '}
                {Patient && (
                  <span>
                    {Patient.gender}
                  </span>
                )}
              </div>
              <div className='patient-part'>
                Rx. ID: {Prescription && <span>{Prescription.id}</span>}
              </div>
              <div className='patient-part'>
              Date : {' '}
                {Prescription && (
                  <span>
                    {moment(Prescription.created_at).format(
                      'D MMM YY, h:mm A'
                    )}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className='prescription-details-container'>
            <div className='details-leftside'>
              <div className='prescription-item'>
                <div className='prescription-item-title'> Chief Complaint (C/C):</div>

                  {Prescription?.chief_complaint ? (
                    Prescription.chief_complaint.includes(',') ? (
                      // Show bullets if there are commas
                      Prescription.chief_complaint.split(',').map((item, index) => (
                        <div key={index} className='prescription-item-content'>
                          * {item.trim()}
                        </div>
                      ))
                    ) : (
                      // Show without bullets if there's no comma
                      <div className='prescription-item-content'>
                        {Prescription.chief_complaint.trim()}
                      </div>
                    )
                  ) : (
                    ''
                  )}
              </div>
              <div className='prescription-item'>
                <div className='prescription-item-title'> Relevant History:</div>

                  {Prescription?.relevant_history ? (
                    Prescription.relevant_history.includes(',') ? (
                      // Show bullets if there are commas
                      Prescription.relevant_history.split(',').map((item, index) => (
                        <div key={index} className='prescription-item-content'>
                          * {item.trim()}
                        </div>
                      ))
                    ) : (
                      // Show without bullets if there's no comma
                      <div className='prescription-item-content'>
                        {Prescription.relevant_history.trim()}
                      </div>
                    )
                  ) : (
                    ''
                  )}
              </div>
              <div className='prescription-item'>
                <div className='prescription-item-title'>On Examination (O/E):</div>
                  {Prescription?.examination ? (
                    Prescription.examination.includes(',') ? (
                      // Show bullets if there are commas
                      Prescription.examination.split(',').map((item, index) => (
                        <div key={index} className='prescription-item-content'>
                          * {item.trim()}
                        </div>
                      ))
                    ) : (
                      // Show without bullets if there's no comma
                      <div className='prescription-item-content'>
                        {Prescription.examination.trim()}
                      </div>
                    )
                  ) : (
                    ''
                  )}
                  {/* Show height and/or weight if they exist and are not 0 or 0.0 */}
                  {Prescription?.height && Prescription.height > 0 && (
                    <div className='prescription-item-content'>* Height (Feet): {Prescription.height}</div>
                  )}
                  {Prescription?.weight && Prescription.weight > 0 && (
                    <div className='prescription-item-content'>* Weight (KG): {Prescription.weight}</div>
                  )}
              </div>
              <div className='prescription-item'>
                <div className='prescription-item-title'>Investigations:</div>
                <div
                  className='prescription-item-content'
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: 'column',
                  }}
                >
                  {Prescription?.investigations
                    ? Prescription.investigations.split(',').map((item, index) => (
                        <div key={index} className='investigation-wrapper'>
                          * {item}
                        </div>
                      ))
                    : ''}
                </div>
              </div>
              <div className='prescription-item'>
                <div className='prescription-item-title'>Advice:</div>
                <div
                  className='prescription-item-content'
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: 'column',
                  }}
                >
                  {Prescription?.advice
                    ? Prescription.advice.split(',').map((item, index) => (
                        <div key={index} className='investigation-wrapper'>
                          * {item}
                        </div>
                      ))
                    : ''}
                </div>
              </div>
            {/*  <div className='prescription-item'>
                <div className='prescription-item-title'> Advice:</div>
                <div className='prescription-item-content'>
                  {!Prescription ? '' : Prescription.investigations}
                </div>
              </div>

               <div className='prescription-item' id='poweredby-sec-left'>
                <div
                  id='powerdby-logo-wrapper-left'
                  style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}
                >
                  <div className='logo-container'>
                    <div className='logo-wrapper'>
                      <img style={{ marginLeft: '0px' }} src={LogoImg} alt='' />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      paddingRight: '10px',
                    }}
                  >
                    {' '}
                    -{' '}
                  </div>

                  <div
                    className='prescription-item-title'
                    id='powred-by-amarlab'
                  >
                    Powered by Amarlab
                  </div>
                </div>
              </div> */}
            </div>

            <div className='details-divider'></div>
            <div className='details-rightside'>
              <div className='prescription-item prescription-main-content'>
                <div className='prescription-item-title'><strong>R</strong>x.</div>
                <div className='prescription-item-content' id='rx-content'>
                  {!Medication
                    ? ''
                    : Medication.map((item, index) => (
                        <div key={'' + index} className='medication-wrapper'>
                          <div className='medication-brief'>
                            <div className='medicine-name'>
                              {item.medication_name},
                            </div>
                            {item.medication_type !== 'Fleet Enema' && (
                              <div className='medication-generic-strength'>
                                <div className='medicine-strength'>
                                  {item.strength}
                                </div>
                              </div>
                            )}
                            <div className='medicine-type'>
                              ({item.medication_type})
                            </div>
                          </div>
                          {/* {item.medication_type !== 'Fleet Enema' && <div className="medication-generic-strength">
                                                <div className="medicine-generic">{item.genetic}</div>
                                                <div className="medicine-strength">{item.strength}</div>
                                            </div>} */}
                          <div className="medication-schedule-box">
                          {(item.medication_type === 'Tablet/Capsule' ||
                            item.medication_type === 'Tablet' ||  item.medication_type === 'Capsule') && (
                            <div className='medication-schedule'>
                              <span>
                                {item.medication_schedule_monring}{' + '}
                                {item.medication_schedule_afternoon}{' + '}
                               {item.medication_schedule_evening}
                                  {/*{item.medication_schedule_before_evening}*/}
                                {/*{item.medication_schedule_night} */}


                              </span>
                            </div>
                          )}
                          <div className='medication-does-meal-days'>
                            {item.medication_type !== 'Tablet/Capsule' &&
                              item.medication_type !== 'Tablet' &&  item.medication_type !== 'Capsule' && (
                                <div className='medication-doseDrop'>
                                  <span>{item.dose_drops_time_puff} Number of Drops,</span>
                                </div>
                              )}
                            {(item.medication_type === 'Tablet/Capsule' ||
                              item.medication_type === 'Tablet' || item.medication_type === 'Capsule' ||
                              item.medication_type === 'Syrup') && (
                              <div className='medication-mealtime'>
                                <span>{item.medication_with_meal},</span>
                              </div>
                            )}
                            {item && item.days && (
                              <div className='medication-days'>
                                <span>{item.days} Days</span>
                              </div>
                            )}
                          </div>
                          </div>
                          {item.medication_type === 'Nebulization' && item.mixture_details && (
                            <div className='medication-mixture'>
                              <span>{item.mixture_details} Mixture</span>
                            </div>
                          )}
                          {item.advice && (
                            <div className='medication-advice'>
                              Note: <span> {item.advice}</span>
                            </div>
                          )}
                        </div>
                      ))}
                </div>
              </div>
            {Medication?.advice && (
                <div className='prescription-item'>
                    <div className='prescription-item-title'>Advice</div>
                    <div className='prescription-item-content'>
                        {Medication.advice}
                    </div>
                </div>
            )}
            <div className="pres-sig-footer">
            {Prescription && Prescription.followup_date && !moment(Prescription.followup_date).format('DD MMM YYYY').includes('Invalid') && (
              <div className='prescription-item' style={{ marginBottom: 0 }}>
                <div className='prescription-item-title'>Followup Date:</div>
                <div className='prescription-item-content'>
                  {/* {Prescription &&
                  Prescription.followup_date &&
                  moment(Prescription.followup_date)
                    .format('DD MMM YYYY')
                    .includes('Invalid')
                    ? moment(Prescription.followup_date).format('DD MMM YYYY')
                    : ' '} */}
                    {moment(Prescription.followup_date).format('DD MMM YYYY')}
                </div>
              </div>
              )}

              <div className='prescription-item' id='signature-sec'>
                {/* <div
                  style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}
                >
                  <div className='prescription-item-title'>Powered By.</div>
                  <div className='logo-container'>
                    <div className='logo-wrapper'>
                      <img style={{ marginLeft: '0px' }} src={LogoImg} alt='' />
                    </div> */}
                {/* <div className="logo-title">e-laj</div> */}
                {/* </div>
                </div> */}
                <div
                  id='powerdby-logo-wrapper-right'
                  style={{ display: 'none', alignItems: 'center', flexGrow: 1 }}
                >
                  <div className='logo-container'>
                    <div className='logo-wrapper'>
                      <img style={{ marginLeft: '0px' }} src={LogoImg} alt='' />
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      paddingRight: '5px',
                    }}
                  >
                    -
                  </div>
                  <div
                    className='prescription-item-title'
                    id='powred-by-amarlab'
                  >
                    Powered by Sneho
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexGrow: 1,
                    justifyContent: 'flex-end',
                  }}
                >
                  <div className='signature-wrapper'>
                    <div className='signature-image-wrapper'>
                      {!!Signature && (
                        <img
                          onLoad={handleLogoLoad}
                          src={Signature}
                          alt='alteration'
                          className='signature-image'
                        />
                      )}
                    </div>
                    <div className='signature-dash'>
                      ------------------------------
                    </div>
                    <div className='signature-footer'>Signature</div>
                  </div>
                </div>
              </div>
            </div>
              {/* <div className='signature-container'> */}
              {/* <div className="signature-wrapper">
                                <div className="signature-image-wrapper">
                                    {!!Signature && <img src={Signature} alt="alteration" className='signature-image' />}
                                </div>
                                <div className="signature-dash">
                                    ------------------------------
                                </div>
                                <div className="signature-footer">
                                    Signature
                                </div>
                            </div> */}
              {/* </div> */}
            </div>
          </div>
          <div className="prescription-footer">
          <p>Powered by AmarLab - Sneho Urgent Healthcare | Address: {Doctor?.address_chamber || ''} <br/> | Mobile: + {Doctor?.mobile_number || ''}</p>
          </div>
        </div>
        </div>
        {/* <><input type="text" id="urlInput" value={prescriptionURL} style={{display: 'none'}}></input></> */}
        <div className='button-container'>


          {/* Modal */}
          {isModalOpen && (
            <InvestigationUploadModal
              prescription={Prescription}
              closeModal={() => setModalOpen(false)}
            />
          )}
          {/* finis modal */}
          {isAdmin() && (
          <div className='copy-container' onClick={openModal}>
            <div className='copy-wrapper'>Upload Investigations (Reports)</div>
          </div>
          )}
          {isDoctor() && (
          <div className='copy-container' onClick={openModal}>
            <div className='copy-wrapper'>Download Investigations (Reports)</div>
          </div>
          )}
          <div className='copy-container' onClick={() => setCopyURL()}>
            <div className='copy-wrapper'>Copy Rx. Url</div>
          </div>
          <div
            className='share-container'
            onClick={() => setShareModalVisible(true)}
          >
            <div className='share-wrapper'>Share</div>
          </div>

          <div
            className='share-container'
            onClick={() => setForPrint()}
          >
            <div className='share-wrapper'>Print</div>
          </div>

          <div
            className='download-container'
            onClick={() => handleDownload()}
          >
            <div className='download-wrapper' >Download</div>
          </div>
        </div>
      </div>
    );
};

export default PrescriptionPreviewPartner;
